'use client';
import { Banner } from '@curology/ui-components-web/react';

import { type Visit } from '@/services/visitsService/types';

const VisitBanner = ({ visit }: { visit: Visit }) => {
  // Offer banner is only shown pre-purchase.
  if (visit.orders.length > 0) {
    return;
  }

  if (!visit.offer) {
    return;
  }

  return (
    <div className="cur-min-h-[34px]">
      <Banner data-sentry-id="Banner">{visit.offer.content.banner}</Banner>
    </div>
  );
};

export { VisitBanner };
